export const PLANS = {
  FREE: "free",
  PRO: "pro",
  TEAM: "team",
};

/**
 * Single source of truth for gated functionality.
 * Note: Team maps to current "premium / owner" runtime plan.
 */
export const PLAN_LIMITS = {
  [PLANS.FREE]: {
    maxMedications: 50,
    maxUsersPerOrg: 1,
    pillCountsPerMonth: 5,
    expiryAlertsEnabled: false,
    bulkImportEnabled: false,
    exportReportsEnabled: false,
    auditLogEnabled: false,
    aiPillCountEnabled: false,
    liveCameraEnabled: false,
    apiAccessEnabled: false,
    prioritySupportEnabled: false,
    dataRetentionDays: 90,
  },
  [PLANS.PRO]: {
    maxMedications: 500,
    maxUsersPerOrg: 3,
    pillCountsPerMonth: 100,
    expiryAlertsEnabled: true,
    bulkImportEnabled: true,
    exportReportsEnabled: true,
    auditLogEnabled: true,
    aiPillCountEnabled: true,
    liveCameraEnabled: true,
    apiAccessEnabled: false,
    prioritySupportEnabled: false,
    dataRetentionDays: 365,
  },
  [PLANS.TEAM]: {
    maxMedications: -1,
    maxUsersPerOrg: -1,
    pillCountsPerMonth: -1,
    expiryAlertsEnabled: true,
    bulkImportEnabled: true,
    exportReportsEnabled: true,
    auditLogEnabled: true,
    aiPillCountEnabled: true,
    liveCameraEnabled: true,
    apiAccessEnabled: true,
    prioritySupportEnabled: true,
    dataRetentionDays: -1,
  },
};

/**
 * Keep aligned with live billing values already used in app pricing.
 */
export const PLAN_DISPLAY = {
  [PLANS.FREE]: {
    name: "Free",
    price: 0,
    currency: "ZAR",
    billingPeriod: null,
    tagline: "See risk on your desk first — upgrade when automation pays for itself",
    ctaLabel: "Current Plan",
  },
  [PLANS.PRO]: {
    name: "Pro",
    price: 749,
    currency: "ZAR",
    billingPeriod: "month",
    tagline: "Alerts, exports, audit trail — automation plus boardroom-ready insight",
    ctaLabel: "Upgrade to Pro",
    highlight: true,
  },
  [PLANS.TEAM]: {
    name: "Team",
    price: 1499,
    currency: "ZAR",
    billingPeriod: "month",
    tagline: "Multi-site teams + the lane for networked inventory intelligence (as it ships)",
    ctaLabel: "Upgrade to Team",
  },
};

export function planSupports(plan, feature) {
  const limits = PLAN_LIMITS[plan];
  if (!limits) return false;
  const value = limits[feature];
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value !== 0;
  return false;
}

export function withinPlanLimit(plan, feature, currentUsage) {
  const limits = PLAN_LIMITS[plan];
  if (!limits) return false;
  const limit = limits[feature];
  if (limit === -1) return true;
  if (typeof limit === "number") return currentUsage < limit;
  return false;
}

export function normalizeRuntimePlan(runtimePlan, isAuthenticated) {
  if (!isAuthenticated) return PLANS.FREE;
  const p = String(runtimePlan || "").toLowerCase();
  if (p === "premium" || p === "team") return PLANS.TEAM;
  if (p === "pro") return PLANS.PRO;
  return PLANS.FREE;
}
